export default [
  {
    path: '/home/friendCircle',
    name: 'homeFriendCircle',
    component: () => import('@views/home/friendCircle.vue'),
    meta: {
      title: '工友圈'
    }
  },
  {
    path: '/friendCircle',
    name: 'friendCircle',
    component: () => import('@views/friendCircle/index.vue'),
    meta: {
      title: '工友圈'
    }
  },
  {
    path: '/myFriendCircle',
    name: 'myFriendCircle',
    component: () => import('@views/friendCircle/myFriendCircle.vue'),
    meta: {
      title: '工友圈'
    }
  },
  {
    path: '/friendCircleMessage',
    name: 'friendCircleMessage',
    component: () => import('@views/friendCircle/message.vue'),
    meta: {
      title: '工友圈'
    }
  },
  {
    path: '/friendCircleAdd',
    name: 'friendCircleAdd',
    component: () => import('@views/friendCircle/add.vue'),
    meta: {
      title: '工友圈'
    }
  },
  {
    path: '/friendCircleDetail',
    name: 'friendCircleDetail',
    component: () => import('@views/friendCircle/detail.vue'),
    meta: {
      title: '工友圈'
    }
  },
  {
    path: '/orgUserInfo',
    name: 'orgUserInfo',
    component: () => import('@views/friendCircle/userInfo.vue'),
    meta: {
      title: '组织'
    }
  }
]
